/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import { mutationOptions, useMutation } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  AnonymizeUserMutationResponse,
  AnonymizeUserPathParams,
} from "../types/AnonymizeUser.ts"

export const anonymizeUserMutationKey = () =>
  [{ url: "/v1/user/:id/anonymize" }] as const

export type AnonymizeUserMutationKey = ReturnType<
  typeof anonymizeUserMutationKey
>

/**
 * @summary Anonymize user
 * {@link /v1/user/:id/anonymize}
 */
export async function anonymizeUser(
  id: AnonymizeUserPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    AnonymizeUserMutationResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: "PUT", url: `/v1/user/${id}/anonymize`, ...requestConfig })
  return res
}

export function anonymizeUserMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const mutationKey = anonymizeUserMutationKey()
  return mutationOptions<
    ResponseConfig<AnonymizeUserMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: AnonymizeUserPathParams["id"] },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id }) => {
      return anonymizeUser(id, config)
    },
  })
}

/**
 * @summary Anonymize user
 * {@link /v1/user/:id/anonymize}
 */
export function useAnonymizeUser<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<AnonymizeUserMutationResponse>,
      ResponseErrorConfig<Error>,
      { id: AnonymizeUserPathParams["id"] },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? anonymizeUserMutationKey()

  const baseOptions = anonymizeUserMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<AnonymizeUserMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: AnonymizeUserPathParams["id"] },
    TContext
  >

  return useMutation<
    ResponseConfig<AnonymizeUserMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: AnonymizeUserPathParams["id"] },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<AnonymizeUserMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: AnonymizeUserPathParams["id"] },
    TContext
  >
}
